import React from "react";
import { ListItem, ListItemIcon, ListItemText, Badge } from "@material-ui/core";
import {
	Home,
	ScheduleOutlined,
	ListAltOutlined,
	DirectionsRunOutlined,
	InventoryOutlined,
	ExpandLess,
	ExpandMore,
	SettingsOutlined,
	EditOutlined,
	DisplaySettingsOutlined,
} from "@mui/icons-material";
import { ReactNode } from "react";
import { useMenuStyles, useMenuItemBadgeStyles } from "./DrawerMenuStyles";
import { navIcon } from "../../utils/consts";
import clsx from "clsx";
const MenuItem: React.FC<{
	name: string;
	selected: boolean;
	icon: navIcon;
	badgeContent?: ReactNode;
	onClick: () => void;
	hasSubMenu?: boolean;
	subMenuExpanded?: boolean;
	isSubMenuItem?: boolean;
}> = (props) => {
	const { name, selected, badgeContent, icon, onClick, hasSubMenu, subMenuExpanded, isSubMenuItem } = props;
	const styles = useMenuStyles();

	//Each menu item can have separate badge bg & text colors
	const menuItemBadgeStyles = useMenuItemBadgeStyles({
		bgColor: "#ff0000",
		textColor: "#fff",
	});
	const MenuItemIcon = () => {
		const className = selected ? styles.selectedIcon : styles.icon;
		switch (icon) {
			case "ScheduleOutlined":
				return <ScheduleOutlined titleAccess={name} className={className} />;
			case "ListAltOutlined":
				return <ListAltOutlined titleAccess={name} className={className} />;
			case "DirectionsRunOutlined":
				return <DirectionsRunOutlined titleAccess={name} className={className} />;
			case "InventoryOutlined":
				return <InventoryOutlined titleAccess={name} className={className} />;
			case "SettingsOutlined":
				return <SettingsOutlined titleAccess={name} className={className} />;
			case "EditOutlined":
				return <EditOutlined titleAccess={name} className={className} />;
			case "DisplaySettingsOutlined":
				return <DisplaySettingsOutlined titleAccess={name} className={className} />;
			default:
				return <Home className={className} />;
		}
	};

	return (
		<ListItem
			button
			disableRipple
			className={clsx(styles.menuItem, {
				[styles.selectedMenuItem]: selected,
			})}
			onClick={onClick}
			style={isSubMenuItem ? { paddingLeft: 32 } : undefined}
		>
			<ListItemIcon>
				<MenuItemIcon />
			</ListItemIcon>
			<ListItemText
				primary={
					badgeContent ? (
						<>
							{name}
							<Badge
								badgeContent={badgeContent}
								classes={{
									badge: clsx(menuItemBadgeStyles.badge, menuItemBadgeStyles.badgeOnExpanded),
								}}
							></Badge>
						</>
					) : (
						name
					)
				}
				className={selected ? styles.selectedText : styles.text}
			/>
			{hasSubMenu && (
				subMenuExpanded ? <ExpandLess className={styles.icon} /> : <ExpandMore className={styles.icon} />)}
		</ListItem>
	);
};

export default MenuItem;
